import React from 'react';
import { DateUtils } from '@vectord/utils';
import classNames from 'classnames';

import {
  SbatGroupInstructors,
  SbatGroupSuperBatches,
} from 'features/classCreation';
import RescheduleButton from '../RescheduleButton';
import styles from './RescheduleClassesViewStageRow.module.scss';
import TableCell from 'components/TableCell';
import TableRow from 'components/TableRow';

export default function RescheduleClassesViewStageRow({ sbatGroup }) {
  return (
    <TableRow
      className={classNames({
        [styles.disabled]: sbatGroup.locked,
      })}
    >
      <TableCell>{DateUtils.toDateDayTime(sbatGroup.date_of_topic)}</TableCell>
      <TableCell>{sbatGroup.academy_topic.title}</TableCell>
      <TableCell>
        <SbatGroupSuperBatches
          trimIfMany
          sbatGroup={sbatGroup}
        />
      </TableCell>
      <TableCell>{sbatGroup.academy_topic.academy_module.name}</TableCell>
      <TableCell>
        <SbatGroupInstructors sbatGroup={sbatGroup} />
      </TableCell>
      <TableCell>
        <RescheduleButton sbatGroup={sbatGroup} />
      </TableCell>
    </TableRow>
  );
}
